export enum ClientEmployeeOQMendixPageId {
  TaskList = 254,
  EmployeeList = 140,
  Assignments = 143,
  Qualifications = 144,
  ExpiringQualifications = 147,
  FieldVerificationReport = 307,
  EmployeeHistory = 1430,
  QRExport = 1498
}

export enum ClientContractorOQMendixPageId {
  VendorReport = 371,
  TaskList = 253,
  FieldVerificationReport = 137,
  Qualifications = 119
}

export enum ContractorOQMendixPageId {
  ActiveEmployees = 288,
  QualifiedEmployees = 103,
  FieldVerificationReport = 99,
  ExpiringQualifications = 397,
  PortIndividuals = 883,
  QRExport = 1498
}

export enum TrainingManagementMendixId {
  TrainingManagement = 789
}

export enum DrugAndAlcoholMendixId {
  ClientIndex = 6,
  ContractorIndex = 463
}
